import { IKContext } from 'imagekitio-react'

const IKProvider = ({ children }) => (
  <IKContext urlEndpoint="https://ik.imagekit.io/jtoar/musicaldetective">
    {children}
  </IKContext>
)

export default IKProvider
